<template>
  <v-container fluid class="register-fond">
    <div class="tapiz"></div>
    <template v-if="pantalla === 1">
      <v-layout>
        <div v-if="cookies" class="cookies pa-3 caption font-weight-regular">
          <span>Este sitio web utiliza cookies para que usted tenga la mejor experiencia de usuario. Si continúa navegando está dando su consentimiento para la aceptación de las mencionadas cookies y la aceptación de nuestra política de cookies, pinche <a target="_blank" href="https://firebasestorage.googleapis.com/v0/b/app-users-cloud.appspot.com/o/html%2Fcookies.html?alt=media&token=b5104824-33dc-4a22-bf0a-921e674d8cba">en este enlace</a> para mayor información.</span>
          <v-btn class="primary" @click="cookies = !cookies">
            Entendido
          </v-btn>
        </div>
        <div>
          <v-alert
            v-model="alertMsg"
            dismissible
            type="info"
          >
            En GestionAyudas estamos tramitando las subvenciones correspondientes al Plan Estatal de Viviendas y para ello hemos suscrito un acuerdo con su Comunidad de Propietarios.<br>
            Para poder continuar con nuestro trabajo necesitamos que cada vecino de su Cdad. nos aporte la información que nos solicitan desde las Administraciones responsables de la concesión de dichas subvenciones.<br>
            Es por ello por lo que le hemos enviado el enlace de registro que le ha traido hasta aquí, para que acceda de modo seguro a nuestro sitio web y cumplimente los formularios que hemos dispuesto para ello.<br>
            Para más información al respecto puede visitar nuestro sitio web <a target="_blank" href="https://gestionayudas.es/">GestionAyudas</a> o, si lo prefiere, puede llamarnos al <b>900 827 907.</b>
          </v-alert>
        </div>
      </v-layout>
      <v-container >
        <v-layout align-center justify-center fill-heiht style="height:450px">
          <v-flex xs12 sm6 md6>
            <v-card color="white" min-height="350px">
              <v-toolbar color="blue" dark>
                <h1>Registro Usuario</h1>
                <v-spacer></v-spacer>
                <v-icon large>person_add</v-icon>
              </v-toolbar>
              <v-card-text>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-text-field
                    label="Correo electrónico"
                    v-validate="'required|email|max:60'"
                    :error-messages="errors.collect('email')"
                    data-vv-name="email"
                    data-vv-as="Correo electrónico"
                    id="email"
                    name="email"
                    maxlength="60"
                    prepend-icon="mail"
                    v-model="email"
                  ></v-text-field>
                  <v-text-field
                    label="password"
                    ref="password"
                    v-validate="'required|min:6|max:20'"
                    :error-messages="errors.collect('password')"
                    data-vv-name="password"
                    data-vv-as="password"
                    id="password"
                    name="password"
                    maxlength="20"
                    type="password"
                    prepend-icon="lock"
                    v-model="password"
                  >
                  </v-text-field>
                  <v-text-field
                    label="Repetir password"
                    v-validate="'required|confirmed:password'"
                    :error-messages="errors.collect('password2')"
                    data-vv-name="password2"
                    data-vv-as="Repetir password"
                    name="password2"
                    id="password2"
                    maxlength="20"
                    type="password"
                    prepend-icon="lock"
                    v-model="passwordRepeat"
                  >
                  </v-text-field>
                  <v-text-field
                    v-if="!token"
                    label="Código de Referencia"
                    v-validate="'required|min:14|max:20'"
                    :error-messages="errors.collect('refcode')"
                    data-vv-name="refcode"
                    data-vv-as="Código de referencia"
                    id="refcode"
                    name="refcode"
                    maxlength="20"
                    prepend-icon="vpn_key"
                    v-model="referenciaCode"
                  ></v-text-field>
                  <!-- <v-checkbox
                    v-model="privacidad"
                    :rules="[v => !!v || 'Debe aceptar para continuar!']"
                    label="Acepto los términos y condiciones"
                    required
                  ></v-checkbox> -->
                  <v-checkbox
                    v-model="privacidad"
                    :rules="[v => !!v || 'Debe aceptar para continuar!']"
                    required
                  >
                    <template v-slot:label>
                      <div>
                        Acepto los
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <a
                              target="_blank"
                              href="https://firebasestorage.googleapis.com/v0/b/app-users-cloud.appspot.com/o/html%2Fprivacidad.html?alt=media&token=fc0667fd-8531-4ed2-9088-87c6af61c628"
                              @click.stop
                              v-on="on"
                            >
                              Términos y Condiciones
                            </a>
                          </template>
                          Abrir en nueva ventana
                        </v-tooltip>
                        de privacidad
                      </div>
                    </template>
                  </v-checkbox>
                  <!-- <v-text-field
                    v-model="email"
                    v-validate="'required|email|max:60'"
                    maxlength="60"
                    prepend-icon="fas fa-user"
                    :error-messages="errors.collect('email')"
                    label="email"
                    data-vv-name="email"
                    data-vv-as="email">
                  </v-text-field>
                  <v-text-field
                    ref="password"
                    v-model="password"
                    v-validate="'required|min:6|max:20'"
                    :error-messages="errors.collect('password')"
                    prepend-icon="fas fa-lock" 
                    maxlength="20"
                    name="password" 
                    label="Password" 
                    id="password" 
                    type="password"
                    data-vv-name="password"
                    :data-vv-as="'password'">
                  </v-text-field>
                  <v-text-field 
                    v-model="passwordRepeat" 
                    v-validate="'required|confirmed:password'"
                    :error-messages="errors.collect('password2')"
                    prepend-icon="fas fa-lock" 
                    maxlength="20"
                    name="password2" 
                    label="Confirm Password" 
                    id="password2" 
                    type="password"
                    data-vv-name="password2"
                    :data-vv-as="'Confirm Password'">
                  </v-text-field> -->
                </v-form>
                <vue-recaptcha
                  ref="recaptcha"
                  @verify="onVerify"
                  @expired="onExpired"
                  :sitekey="sitekey"
                >
                </vue-recaptcha>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  @click="sendForm"
                  :disabled="desactiveButton"
                  >Enviar</v-btn
                >
                <!-- <v-btn
                  color="error"
                  @click="testFunctions"
                  >Test Functions
                  </v-btn> -->
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
          
      </v-container>
    </template>
    <template v-if="pantalla === 2">
      <v-layout align-center justify-center fill-heiht>
        <div>
          <v-alert
            v-model="alertSending"
            type="success"
          >
            El registro se ha realizado con éxito.<br>
            Por favor abra su email y valide su cuenta mediante el enlace que recibirá en los próximos minutos.<br>
            Una vez valida su cuenta de correo, ya podrá acceder a su zona privada mediante el correo y el password que nos acaba de proporcionar.
          </v-alert>
        </div>
      </v-layout>
    </template>
    <template v-if="pantalla === 3">
      <v-layout align-center justify-center fill-heiht>
        <div>
          <v-alert
            v-model="alertSending"
            type="error"
          >
            Ops!.<br>
            Ha ocurrido un error.<br>
            Por favor inténtelo de nuevo pasados unos minutos. Si el problema persiste, por favor póngase en contacto con nosotros en horario laboral en el 900 827 907, o envíenos un correo a  info@gestiónayudas.es
            <v-btn @click="pantalla=1">
              Volver a intentar
            </v-btn>
          </v-alert>
        </div>
      </v-layout>
    </template>
  </v-container>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
import axios from "axios";
export default {
  components: { "vue-recaptcha": VueRecaptcha },
  data: () => ({
    sitekey: "6LfKvqMUAAAAALqAtlHdRe--ygGFgk59D24UCCDw",
    activeReCaptcha: true,
    sending: false,
    inLogin: false,
    positionReCaptcha: null,
    valid: false,
    email: "",
    password: "",
    passwordRepeat: "",
    referenciaCode: "",
    humanForm: null,
    alert: false,
    errorMessage: "",
    privacidad: false,
    alertMsg: true,
    cookies: true,
    pantalla: 1,
    alertSending: true
  }),
  mounted() {
    this.$refs.form.resetValidation();
  },
  computed: {
    desactiveButton() {
      let refCodeValid = this.referenciaCode.length > 0;
      if (this.token) {
        refCodeValid = true;
      }
      const result = this.privacidad && this.valid && this.password.length > 0 && this.email.length > 0 && this.passwordRepeat.length > 0 && refCodeValid && this.humanForm;
      return !result;
    },
    token() {
      return this.$route.params.token || null;
    }
  },
  methods: {
    testFunctions() {
      const addMessage = this.$functions.httpsCallable('addMessage');
      addMessage({text: 'Prueba de mensaje desde cliente JS'})
        .then(function(result) {
          // const sanitizedMessage = result.data.text;
          console.log(result);
        })
        .catch(function(error) {
          console.log(error);
          // Getting the Error details. 
          // var code = error.code;
          // var message = error.message;
          // var details = error.details;
          // ...
        });
    },
    sendForm() {
      this.sending = true;
      const data = {
        email: this.email,
        password: this.password,
        humanForm: this.humanForm,
        token: this.token,
        referenciaCode: this.referenciaCode
      };
      const url = "https://usuarios.gestionayudas.es/api/newUser";
      axios({
        method: 'POST',
        url: url,
        headers:
        {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json'
        },
        data: data
      })
      .then((res) => {
          if (res.status == 200) {
              console.log('*** status 200 ***');
            this.pantalla = 2;
            return;
          }
          console.log(JSON.stringify(res.data));
          this.pantalla = 3;
      })
      .catch(function (err) {
          console.log(err);
          this.pantalla = 3;
      });
    },
    onExpired() {
      this.humanForm = null;
    },
    onVerify(response) {
      this.humanForm = response;
      // 6LfKvqMUAAAAAIjzf1WWYh70SJ9ELlZONidyJSSz => Servidor
      /* console.log('Verify: ' + response)
      this.humanForm = response
      this.activeReCaptcha = false
      this.sending = true
      const payload = {
          email: this.email,
          password: this.password,
          humanForm: this.humanForm,
          lang: this.lang || 'en'
      }
      this.registerNewUser(payload) */
    }
  }
};
</script>

<style scoped>
@media (max-width: 640px) and (orientation: landscape) {
  .register-fond {
    background-image: url(../assets/register_640.jpg);
  }
}
@media (min-width: 641px) {
  .register-fond {
    background-image: url(../assets/register_1280.jpg);
  }
}
@media (min-width: 1281px) {
  .register-fond {
    background-image: url(../assets/register_1920.jpg);
  }
}
.tapiz {
  position: absolute;
  width: 100vw;
  height: 100vh;
  background-color: #098519;
  opacity: 0.6;
  margin: 0px;
  padding: 0px;
  top: 0px;
  left: 0px;
}

.cookies {
  position: fixed;
  bottom: 5px;
  background-color: white;
  width: 95vw;
}
</style>
